import {
  selectSelectorGenerator,
  writeSelectorGenerator,
} from '../qa-hooks/typedSelectorHelpers';

const QaHooks = {};

const hooks = {
  tosCheckbox: 'tosCheckbox',
};

const Selectors = { ...selectSelectorGenerator(hooks), ...QaHooks };
const WriteSelectors = writeSelectorGenerator(hooks);

export { Selectors, WriteSelectors };
